export default {"src":"/_next/static/media/renewable_energy_40.7d79d8f9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};